import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const ConnectorSlice =  createSlice({
    name:"Connector",
    initialState:{
        id:"",
    },
    reducers:{
        SetConnector(state, action: PayloadAction<any>){
            state.id = action.payload;

        }
    }
});

export const { SetConnector } =ConnectorSlice.actions
export default ConnectorSlice.reducer